<template lang="pug">
	div
		.article-wrap
			.article
				h1 {{items.mainHeader}}
				p
					vue-markdown {{items.welcomeText}}

		.article-wrap.testimonials
			.article
				h1 Отзывы
				flickity(ref="flickityTestimonials" :options="{}" class="testimonials__wrap" v-if="loaded")
					.testimonials__item(v-for="testimonial in testimonials")
						.testimonials__item-left
							.testimonials__item-pic(:style="'background-image: url('+testimonial.testimonialPhoto.fields.file.url+');'")
						.testimonials__item-right
							.testimonials__item-name {{testimonial.testimonialName}}
							.testimonials__item-desc {{testimonial.testimonialDesc}}
							.testimonials__item-text {{testimonial.testimonalText}}
						

		.article-wrap.whatis
			.article
				h1 {{items.videohead}}
				p
					vue-markdown {{items.videoText}}
				.video
					iframe(width="560" height="349" :src="items.videourl" frameborder="0" allowfullscreen allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture")

		.article-wrap.schedule
			.article
				h1 {{items.scheduleHead}}
				p
					vue-markdown {{items.scheduleText}}
			.schedule-signup-wrap
				.schedule-signup-button(@click="toggleSignup") Записаться


		.article-wrap.prices
			.article
				h1 {{items.pricesHead}}
				p
					vue-markdown {{items.pricesText}}

		.article-wrap.certificates
			.article
				.certificates-wrap
					.certificates-text
						h1 {{items.certificatesHead}}
						vue-markdown {{items.certificatesText}}
					.certificates-pic


		.article-wrap.contacts
			.article
				h1 {{items.contactsHeader}}
				.contacts-wrap
					.contacts-wrap-left
						.contacts-text
							vue-markdown {{items.contactsText}}
						.contacts-maps
							.contacts-maps-wrap
								a.contacts-maps-link(href="https://yandex.ru/maps/216/zelenograd/?from=tabbar&ll=37.218447%2C55.996610&mode=search&oid=184676022630&ol=biz&sctx=ZAAAAAgBEAAaKAoSCYnQCDauz0JAEabtX1lp4EtAEhIJA137Anqh8j8RmPxP%2Fu4d7D8oCjAAOPXEuajnh4DUXkDwkQdIAVXNzMw%2BWABqAnJ1cACdAc3MzD2gAQCoAQA%3D&sll=37.218447%2C55.996610&sspn=0.007489%2C0.002459&text=gotango&z=18" target="_blank")
									.contacts-maps-icon.yandex
									.contacts-maps-text Яндекс-карты
							.contacts-maps-wrap
								a.contacts-maps-link(href="https://www.google.com/maps/place/%D0%A8%D0%BA%D0%BE%D0%BB%D0%B0+%D0%B0%D1%80%D0%B3%D0%B5%D0%BD%D1%82%D0%B8%D0%BD%D1%81%D0%BA%D0%BE%D0%B3%D0%BE+%D1%82%D0%B0%D0%BD%D0%B3%D0%BE+GoTango/@55.9969636,37.2171246,17z/data=!4m5!3m4!1s0x46b5150bd9abc27d:0xa104e0d4e9eea01a!8m2!3d55.9968711!4d37.2169996?hl=ru" target="_blank")
									.contacts-maps-icon.google
									.contacts-maps-text Google-карты

						h1.social-head Мы в соцсетях
						.social-icons
							a.social-icon.ig(href="https://www.instagram.com/gotango_zel/" target="_blank")
							a.social-icon.fb(href="https://www.facebook.com/gotangozel/" target="_blank")
							a.social-icon.vk(href="https://vk.com/gotango_zelenograd" target="_blank")
							a.social-icon.tg(href="https://t.me/gotango_zel" target="_blank")

					.contacts-wrap-right
						flickity(ref="flickityContacts" :options="flickityOptions" v-if="loaded")
							.contacts-gallery-img-wrap(v-for="photo in items.contactsPhotos")
								img.contacts-gallery-img(:data-flickity-lazyload="photo.fields.file.url")
								.contacts-gallery-img-caption {{photo.fields.title}}
</template>

<script>
/* eslint-disable */
// @ is an alias to /src
import { mapGetters, mapMutations } from "vuex";
import VueMarkdown from "vue-markdown";
import Flickity from "vue-flickity";

export default {
	name: "home",
	computed: {
		...mapGetters({
			items: "main/mainPageItems",
			testimonials: "main/testimonialItems",
			loading: "main/loading",
			loaded: "main/loaded",
			showSignup: "main/showSignup"

		})
	},
	methods:{
		...mapMutations({toggleSignup:"main/toggleSignup"}),
	},
	data() {
		return {
			flickityOptions: {
				initialIndex: 0,
				autoPlay: false,
				prevNextButtons: true,
				pageDots: true,
				wrapAround: false,
				lazyLoad: 1,
				adaptiveHeight: true

				// any options from Flickity can be used
			}
		};
	},
	components: {
		VueMarkdown,
		Flickity
	}
};
</script>

<style lang="stylus">
.article
	margin 0 auto
	max-width 1000px
	padding 30px 20px 20px

	&-wrap
		background-color white

.certificates
	background-color #2b1c30

	h1
		padding-top 30px
		color #c173ad

	.article
		padding 0 20px
	&-wrap
		display flex
		width 100%
		padding 20px 0
		
		@media screen and (max-width: 1000px)
			display block
	&-text
		flex 2
		padding-bottom 20px
		padding-right 20px
		div
			color #eac0e0
		@media screen and (max-width: 1000px)
			padding-bottom 0

	&-pic
		flex 1.1
		background transparent url('../assets/cert.png') no-repeat top right
		background-size contain
		@media screen and (max-width: 1000px)
			display inline-block
			height 50vh
			width 100%
			background-position center center

.testimonials
	background-color #f9ebf9


	@media screen and (max-width: 1000px)
		.flickity-prev-next-button.previous
			left -5px

		.flickity-prev-next-button.next
			right -5px

	.article
		padding-bottom 0

	&__item
		width 100%
		height 400px
		@media screen and (max-width: 1000px)
			height auto

		&-pic
			height 400px
			background-size contain
			width 100%
			background-position bottom center
			background-repeat no-repeat

			@media screen and (max-width: 1000px)
				background-position top center
				width 100%
				height 0
				padding-top 100%
				border-radius 50%
				border 3px solid white
				background-color #71356f

		&-left, &-right
			box-sizing border-box
			display inline-block
			vertical-align top

		&-left
			width 40%

			@media screen and (max-width: 1000px)
				width 10%

		&-right
			width 60%
			box-sizing border-box
			padding-left 20px

			@media screen and (max-width: 1000px)
				width 90%

		&-name
			font-size 24px
			font-weight bold
			padding-bottom 5px
			color #754a73

		&-desc
			font-size 15px
			padding-bottom 15px
			color #777

		&-text
			line-height 1.5em
			position relative
			font-style italic
			font-family serif
			padding 0 50px
			font-size 20px
			margin-left -14px

			@media screen and (max-width: 1000px)
				padding 0 10px 15px
				font-size 17px

			&:before
				content '“'
				top 6px
				left 0

			&:after
				content '„'
				bottom 20px
				right 0

			&:after, &:before
				font-size 80px
				position absolute
				color #dcdcdc

				@media screen and (max-width: 1000px)
					content ''

.whatis
	background #3a2239 url('../assets/film.png') no-repeat bottom left
	background-size contain

	h1, p
		color white
		padding-bottom 15px

.video
	position relative
	padding-bottom 56.25% /* 16:9 */
	padding-top 25px
	height 0
	margin-bottom 30px

	iframe
		position absolute
		top 0
		left 0
		width 100%
		height 100%

.schedule
	background white

	p:last-child
		padding-bottom 0

	&-signup
		&-wrap
			text-align center

		&-button
			font-family: Oswald;
			font-size: 25px;
			background-color: #71356f;
			color: #fff;
			text-transform: uppercase;
			display: inline-block;
			padding: 4px 10px;
			margin-bottom: 20px;
			margin-left: -10px;
			cursor: pointer;
			transition 0.5s all
			&:hover
				text-shadow 0 0 10px #ffffffff


.prices
	background #f8ecff url('../assets/500.jpg')
	background-size cover

.contacts
	background #231d23

	h1
		color #a97a9d

	.article
		padding-bottom 30px

	&-text
		color #f1d7f1

		a
			color #ff61ff
			font-weight bold
			text-decoration none

	&-wrap
		&-left, &-right
			width 50%
			display inline-block
			vertical-align top
			box-sizing border-box

			@media screen and (max-width: 800px)
				width 100%
				margin-bottom 30px

		&-right
			padding-left 30px

			@media screen and (max-width: 800px)
				padding-left 0

	&-gallery
		&-img
			object-fit cover
			position absolute
			top 0
			left 0
			width 100%
			height 100%

			&-wrap
				position relative
				width 100%
				padding-top 100%
				object-fit cover
				float left

			&-caption
				position absolute
				bottom 0
				left 0
				right 0
				height 50px
				color white
				text-align center
				background-color rgba(0, 0, 0, .6)
				line-height 1.5em
				padding-top 5px
				display flex
				align-items center
				justify-content center

	&-maps
		&-link
			text-decoration none
			display inline-block
			width 100px
			height 120px
			text-align center
			transition .5s all

			&:hover
				.contacts
					&-maps
						&-icon
							opacity 1

						&-text
							color #e054dc
							border-bottom 1px dashed #e054dc

		&-icon
			display inline-block
			width 100px
			height 100px
			opacity .2
			transition .5s all

			&.yandex
				background url('../assets/ym.png') no-repeat top center

			&.google
				background url('../assets/gm.png') no-repeat top center

		&-text
			border-bottom 1px dashed #ab4ea8
			color #ab4ea8
			font-weight bold
			display inline
			text-decoration none
			transition .5s all
			white-space nowrap

		&-wrap
			width 140px
			text-align left
			display inline-block

.social
	&-head
		padding-top 50px

	&-icon
		display inline-block
		width 60px
		height 60px
		margin-right 30px
		margin-bottom 30px
		opacity .2
		transition .5s all
		background-size cover
		background-position center center
		background-repeat no-repeat

		&:hover
			opacity 1

		&:last-child
			margin-right 0

		&.fb
			background-image url('../assets/fb.png')

		&.ig
			background-image url('../assets/ig.png')

		&.vk
			background-image url('../assets/vk.png')

		&.tg
			background-image url('../assets/tg.svg')

</style>
